import { useThemeColors } from '@/hooks/useThemeColors';
import { Link } from '@inertiajs/react';
import { ChevronRight, Video } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface AmaSessionsCardProps {
    courseSlug: string;
}

const AmaSessionsCard: React.FC<AmaSessionsCardProps> = ({ courseSlug }) => {
    const { t } = useTranslation();
    const colors = useThemeColors();

    return (
        <div className="mb-8 overflow-hidden rounded-2xl bg-gradient-to-br from-theme-lighter to-theme-lightest p-6 shadow-sm ring-1 ring-theme-border/50">
            <Link
                href={`/courses/${courseSlug}/ama-series/`}
                className="flex items-center justify-between"
            >
                <div className="flex items-center gap-4">
                    <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-theme-primary/10">
                        <Video className="h-6 w-6 text-theme-primary-text" />
                    </div>
                    <div>
                        <h2 className="text-lg font-semibold text-gray-800">
                            {t('course.amaRecordedSessions', 'Sesiones AMA grabadas')}
                        </h2>
                        <p className="text-sm text-gray-600">
                            {t('course.viewRecordedAmaSessions', 'Ver sesiones de preguntas y respuestas grabadas')}
                        </p>
                    </div>
                </div>
                <ChevronRight className="h-6 w-6 text-theme-text" />
            </Link>
        </div>
    );
};

export default AmaSessionsCard;
